export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_FREE_ACCOUNT = 'free-account-launch';
export const EXPERIMENT_PROGRESS_PANEL_TOOLTIP = 'progress-panel-tooltip';
export const EXPERIMENT_SIGN_IN_PANEL_REDESIGN = 'sign-in-panel-redesign';
export const EXPERIMENT_COOKIE_BANNER = 'cookie-banner';

export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';
export const FF_PIXEL_TRACKING = 'marketing-pixel-tracking';
export const FF_IMPLEMENT_SPACES = 'implement-spaces';
export const FF_SIGNUP_VERIFICATION = 'signup-verification';
export const FF_TRANSFER_VERIFICATION_NEW_UI = 'transfer-verification-new-ui';
export const FF_OTP_VERIFICATION = 'otp-verification';
export const FF_VERIFICATION_LINK = 'user-verification-link';
